import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface AppInfo {
  version: string;
  releaseDate: string;
  buildNumber?: string;
  releaseNotes?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {
  private appInfo: AppInfo = {
    version: '1.0.0',
    releaseDate: '2024-12-08',
    //buildNumber: '2024.12.08.001',
    releaseNotes: [
      'Optymalizacja ładowania danych',
      'Poprawki w systemie cachowania'
    ]
  };

  constructor() {}

  getAppInfo(): AppInfo {
    return {
      ...this.appInfo,
      // Add environment info if available
      version: environment.version || this.appInfo.version,
      releaseDate: environment?.releaseDate || this.appInfo.releaseDate  ,
    };
  }

  getVersionString(): string {
    const info = this.getAppInfo();
    return `v${info.version} (${info.buildNumber})`;
  }

  getFormattedReleaseDate(): string {
    const info = this.getAppInfo();
    const date = new Date(info.releaseDate);
    return date.toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}